import { Box, Text, Stack, Badge, Group } from '@mantine/core'

const signalColors = {
  mobilizer: 'orange',
  stabilizer: 'blue',
  connector: 'green',
  strategist: 'violet',
}

const signalIcons = {
  mobilizer: '⚡',
  stabilizer: '🛡️',
  connector: '🔗',
  strategist: '🎯',
}

function ChoiceCard({ choice }) {
  const { beat_name, choice_text, profile_signal, observation } = choice
  const color = signalColors[profile_signal] || 'cyan'

  return (
    <Box
      style={{
        padding: '14px 16px',
        borderRadius: 8,
        background: 'rgba(10, 22, 40, 0.5)',
        border: '1px solid rgba(0, 255, 255, 0.08)',
      }}
    >
      <Stack gap="sm">
        <Group gap="sm" justify="space-between" wrap="nowrap">
          <Text size="xs" c="dimmed" ff="Orbitron, sans-serif" fw={600} tt="uppercase" lts={1}>
            {beat_name}
          </Text>
          {profile_signal && (
            <Badge size="sm" variant="light" color={color} leftSection={signalIcons[profile_signal]}>
              {profile_signal}
            </Badge>
          )}
        </Group>

        <Text
          size="sm"
          c="cyan.2"
          ff="Rajdhani, sans-serif"
          fw={500}
          style={{
            background: 'rgba(0, 229, 255, 0.04)',
            padding: '8px 12px',
            borderRadius: 4,
            borderLeft: '3px solid rgba(0, 229, 255, 0.4)',
          }}
        >
          "{choice_text}"
        </Text>

        {observation && (
          <Text size="sm" c="gray.4" lh={1.6}>
            {observation}
          </Text>
        )}
      </Stack>
    </Box>
  )
}

export function ChoiceBreakdown({ choices = [] }) {
  if (choices.length === 0) return null

  return (
    <Stack gap="sm">
      {choices.map((choice, i) => (
        <ChoiceCard key={i} choice={choice} />
      ))}
    </Stack>
  )
}
